import { Chip } from "components/DesignSystem/Chips/Chips";
import { Filter } from "components/DesignSystem/Filter/Filter";
import {
  ConditionalRender,
  TaskTrackerTrackerFilterType,
} from "./SalesTaxTracker";
import {
  DUE_FILINGS,
  FilterOption,
  PENDING_REGISTRATIONS,
  SERVICE_TEAM_IDS,
  TASK_STATUS,
  UNASSIGNED_PREPARER,
  UNASSIGNED_SERVICE_TEAM,
} from "./TaskTrackerOptions";
import { useQuery } from "hooks/useQuery";
import { TASK_TYPE } from "store/apis/taskTrackerSalesTax";

export const SalesTaxTrackerFilter = ({
  filter,
}: {
  filter: TaskTrackerTrackerFilterType;
}) => {
  const { updateFilter, values } = filter;
  const query = useQuery();

  const selectedTab = query.get("tab") || TASK_TYPE.FILINGS;

  const handleQuickFilter = (
    name: keyof FilterOption,
    value?: string | boolean
  ) => {
    updateFilter(name, value);
    if (name === PENDING_REGISTRATIONS || name === DUE_FILINGS) {
      updateFilter(TASK_STATUS, "");
    }
    if (name === UNASSIGNED_SERVICE_TEAM) {
      updateFilter(SERVICE_TEAM_IDS, "");
    }
  };

  return (
    <Filter.Root
      defaultValue=""
      title=""
      trigger={<></>}
      hideDivider
      capsule={
        <>
          <ConditionalRender
            fallback={
              <Chip
                onRemove={() =>
                  handleQuickFilter(PENDING_REGISTRATIONS, undefined)
                }
                isActive={Boolean(values.PENDING_REGISTRATIONS)}
                filterType={PENDING_REGISTRATIONS}
                onClick={() => handleQuickFilter(PENDING_REGISTRATIONS, true)}
                isFixedFilter
              >
                Pending Registrations
              </Chip>
            }
            condition={selectedTab === TASK_TYPE.FILINGS}
          >
            <Chip
              onRemove={() => handleQuickFilter(DUE_FILINGS, undefined)}
              isActive={Boolean(values.DUE_FILINGS)}
              filterType={DUE_FILINGS}
              onClick={() => handleQuickFilter(DUE_FILINGS, true)}
              isFixedFilter
            >
              Due Filings
            </Chip>
          </ConditionalRender>
          <Chip
            onRemove={() =>
              handleQuickFilter(UNASSIGNED_SERVICE_TEAM, undefined)
            }
            isActive={Boolean(values.UNASSIGNED_SERVICE_TEAM)}
            filterType={UNASSIGNED_SERVICE_TEAM}
            onClick={() => handleQuickFilter(UNASSIGNED_SERVICE_TEAM, true)}
            isFixedFilter
          >
            Unassigned Team
          </Chip>
          <Chip
            onRemove={() => handleQuickFilter(UNASSIGNED_PREPARER, undefined)}
            isActive={Boolean(values.UNASSIGNED_PREPARER)}
            filterType={UNASSIGNED_PREPARER}
            onClick={() => handleQuickFilter(UNASSIGNED_PREPARER, true)}
            isFixedFilter
          >
            Unassigned Preparer
          </Chip>
        </>
      }
    >
      <></>
    </Filter.Root>
  );
};
